import gt from 'semver/functions/gt';

import { Release } from '../models/release.model';

export function isNewerVersion(version: string, than: string): boolean {
    return gt(version, than);
}

/** Hides beta-only changes, and releases left with none, from non-beta users. */
export function filterReleasesForUser(
    releases: Release[],
    isBetaMode: boolean,
): Release[] {
    if (isBetaMode) return releases;
    return releases
        .map((release) => ({
            ...release,
            changes: release.changes.filter((change) => !change.betaOnly),
        }))
        .filter((release) => release.changes.length > 0);
}

export function getUnseenReleases(
    releases: Release[],
    lastSeenVersion: string,
): Release[] {
    return releases.filter((release) =>
        isNewerVersion(release.version, lastSeenVersion),
    );
}
